import { Alert } from "@/components/ui/alert"
import {
  OrganizationType,
  ProfileDeductions_QueryFragmentFragment,
} from "@/generated/graphql"
import { useCurrentOrganization } from "@/novus/hooks/useCurrentOrganization"
import React from "react"
import DeductionsList from "./DeductionsList"

export const Deductions = ({
  deductions,
  loading,
  fetchMore,
  requiresFiveTwoNineAccounts,
}: {
  deductions: ProfileDeductions_QueryFragmentFragment["deductions"]
  loading: boolean
  fetchMore: (after: string) => void
  requiresFiveTwoNineAccounts: boolean
}) => {
  const { organization } = useCurrentOrganization()

  return (
    <>
      {!organization ? (
        <Alert variant="error">
          To use Hadley deduction benefits, your organization must create an
          account with Hadley and invite you to it. Please reach out to your HR
          contact to see if your organization offers 529 benefit with Hadley.
        </Alert>
      ) : requiresFiveTwoNineAccounts ? (
        <Alert variant="error">
          Please complete the beneficiary information prior to creating a
          deduction.
        </Alert>
      ) : organization.organizationType === OrganizationType.HadleyLight ? (
        <Alert variant="default">
          <p>
            You currently cannot set up automated paycheck-deducted
            contributions. Please download the Hadley app, log in, and set up
            weekly, monthly, and annual recurring contributions to your accounts
            as well as to others' accounts.
          </p>
          <p>
            Track eligible 529 contributions that are deductible from income
            taxes in the Hadley app's Tax Center.
          </p>
        </Alert>
      ) : !organization.supportsDeductions ? (
        <Alert variant="error">
          <span className="font-bold">Almost Ready!</span> Your organization
          admin has to complete a few more steps before you can create a
          deduction. Please check back soon!
        </Alert>
      ) : organization.payrollLocked ? (
        <>
          <Alert variant="default" className="mb-8">
            <span className="font-bold">Payroll Locked!</span> Payroll changes
            are currently locked for your organization. Please adjust your
            deductions once the next payroll period begins.
          </Alert>
          <DeductionsList
            data={deductions}
            loading={loading}
            fetchMore={fetchMore}
          />
        </>
      ) : (
        <DeductionsList
          data={deductions}
          loading={loading}
          fetchMore={fetchMore}
        />
      )}
    </>
  )
}
